import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini-perfomance-snapshot',
  templateUrl: './mini-perfomance-snapshot.component.html',
  styleUrls: ['./mini-perfomance-snapshot.component.css']
})
export class MiniPerfomanceSnapshotComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
